import React from "react"
import { Box, Flex, Button, Text } from "@chakra-ui/react"
import { Headline } from "../section/Headline"
import { Container } from "../layout/Container"
import { Image } from "../image/Image"
import { colors } from "../colors/colors"

import {
  ChevronDownIcon,
  ChevronRightIcon,
  ChevronUpIcon,
} from "@chakra-ui/icons"
import { useState } from "react"

export function Partners({
  title,
  description,
  containerProps = {},
  partners,
}) {
  const [showDescriptions, setShowDescriptions] = useState(undefined)
  return (
    <Container
      id={title && title.toLowerCase()?.split(" ").join("-")}
      {...containerProps}
    >
      <Box mb="60px">
        <Headline title={title} description={description} />
      </Box>

      {partners.map(({ rowImage, descriptions }, index) => {
        const showLine = partners.length - 1 !== index ? <hr /> : null
        return (
          <Box
            as="button"
            _hover={{
              bg: `#F2F2F7`,
            }}
            display="block"
            w="100%"
            onClick={() => {
              if (showDescriptions === index) {
                return setShowDescriptions(undefined)
              }
              setShowDescriptions(index)
            }}
          >
            <Flex p={{ base: `30px 0`, md: "65px 0" }}>
              <Box flex="1 0 0px" alignSelf="center">
                <Box maxW="220px">
                  <Image image={rowImage?.localFile} />
                </Box>
              </Box>
              <Box flex="0 0 auto" alignSelf="center">
                {descriptions?.length > 0 && (
                  <Button
                    background="none"
                    border="none"
                    fontFamily="Teko"
                    fontSize="18px"
                    color={colors.purple}
                    textTransform="uppercase"
                    _hover={{ background: `none` }}
                    onClick={() => {
                      if (showDescriptions === index) {
                        return setShowDescriptions(undefined)
                      }
                      setShowDescriptions(index)
                    }}
                  >
                    <Box pt="4px">Learn More</Box>
                    <Box as="span" fontSize="24px">
                      {showDescriptions === index ? (
                        <ChevronUpIcon color={colors.purple} />
                      ) : (
                        <ChevronDownIcon color={colors.purple} />
                      )}
                    </Box>
                  </Button>
                )}
              </Box>
            </Flex>

            {showDescriptions === index ? (
              <Box>
                {descriptions.map(({ image, paragraphs }) => {
                  return (
                    <Flex flexWrap="wrap" mb="60px">
                      {image && (
                        <Box flex="0 0 100%" mb={{ base: `30px`, md: "80px" }}>
                          <Box maxW={{ base: `91px`, md: "182px" }} m="0 auto">
                            <Image image={image?.localFile} />
                          </Box>
                        </Box>
                      )}

                      {paragraphs?.map(({ text }) => {
                        return (
                          <Box flex="0 0 100%">
                            <Text
                              fontSize={{ base: `16px`, md: "20px" }}
                              color="black"
                              mb="16px"
                              lineHeight={{ base: `22px`, md: "30px" }}
                              dangerouslySetInnerHTML={{ __html: text }}
                            />
                          </Box>
                        )
                      })}
                    </Flex>
                  )
                })}
              </Box>
            ) : (
              showLine
            )}
          </Box>
        )
      })}
    </Container>
  )
}
